import { render, staticRenderFns } from "./YinhuashuiTable.vue?vue&type=template&id=6625c612&scoped=true&"
import script from "./YinhuashuiTable.vue?vue&type=script&lang=js&"
export * from "./YinhuashuiTable.vue?vue&type=script&lang=js&"
import style0 from "./YinhuashuiTable.vue?vue&type=style&index=0&id=6625c612&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6625c612",
  null
  
)

export default component.exports